// extracted by mini-css-extract-plugin
module.exports = {"techRow":"TechnologyReportRow_techRow__yzzpt","techName":"TechnologyReportRow_techName__2uL_y"};